import {timer} from 'rxjs';

export interface RetryStrategyWithIncreasedDelayConfig {
    reconnectDelayStep: number;
    maxReconnectDelay: number;
}

const SECOND = 1000;

const DEFAULT_CONFIG: RetryStrategyWithIncreasedDelayConfig = {
    reconnectDelayStep: 3 * SECOND,
    maxReconnectDelay:  60 * SECOND
};

export const retryStrategyWithIncreasedDelay = (
    {reconnectDelayStep, maxReconnectDelay}: RetryStrategyWithIncreasedDelayConfig = DEFAULT_CONFIG
) =>
    (_error: any, retryCount: number) => {
        const currentReconnectDelay = Math.min(
            retryCount * reconnectDelayStep,
            maxReconnectDelay
        );

        return timer(currentReconnectDelay);
    };
